import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";

const Layout = () => {
  return (
    <div className="App bg-[#f5f5f5] min-h-screen flex flex-col">
      <Navbar />
      <div className="container mx-auto flex-grow">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
